module.exports = __webpack_public_path__ + "assets/img/modal-avatar-846d5b8f.png";